<template>
  <v-container>
    <section class="mt-2 mb-10">
      <h1 v-if="me" class="font-size--24 mt-10">펀다에이아이BNPL 결제 한도</h1>
    </section>
    <GetOffer
      :loading.sync="getOfferLoading"
      :offer.sync="offer"
      :options="componentGetOffer.options"
      @update:offer="handleOfferUpdate"
    >
      <div></div>
    </GetOffer>

    <section class="mb-10">
      <p class="font-size--18 color--nice-grey font-weight-bold mb-0">결제 가능한 한도는</p>
      <h1 class="font-size--35 font-weight-black">
        <v-layout :justify-center="!offer || offer.amount === 0">
          <v-fade-transition hide-on-leave>
            <!-- 오퍼 없거나 상태가 미완료일때 -->
            <div v-if="isOfferInProgress" class="text-center">
              <v-progress-circular size="36" class="my-10" color="grey" indeterminate />
              <p class="font-size--12 color--nice-grey font-weight-normal">
                한도 산출까지는 수~수십 분이 소요될 수 있습니다. <br />이 창을 닫아도 한도 산출은
                진행되므로, 잠시 후 다시 확인하셔도 됩니다.
              </p>
            </div>

            <!-- 가능 금액 없을 때 -->
            <span v-else-if="offer && offer.amount === 0"> - 원 </span>

            <!-- 한도 산출 완료 -->
            <span v-else> {{ commaFormat(offer.amount) }} 원 </span>
          </v-fade-transition>
        </v-layout>
      </h1>

      <!-- 대출 조건 정보 추가 -->
      <div v-if="offer && offer.status === 'completed'" class="loan-terms mt-4">
        <div class="term-item">
          <span class="term-label">연금리</span>
          <span class="term-value">{{ formattedInterestRate }}%</span>
        </div>
        <div class="term-item">
          <span class="term-label">플랫폼수수료</span>
          <span class="term-value">{{ formattedCommissionRate }}%</span>
        </div>
        <div class="term-item">
          <span class="term-label">상환 방법</span>
          <span class="term-value"
            >일매출의 {{ formattedRepaymentRatio }}%로 자동 일상환(완제시까지)</span
          >
        </div>
      </div>
    </section>

    <section class="mb-4">
      <!-- 오퍼의 상태가 미완료일때 -->
      <BasicButton v-if="isOfferInProgress" depressed height="48" disabled>
        한도 산출 중
      </BasicButton>

      <!-- 한도 산출 완료 -->
      <div v-else>
        <BasicButton
          depressed
          height="48"
          :disabled="!isLoanRequestable || requestLoanLoading"
          :loading="requestLoanLoading"
          @click="goToMain"
        >
          서비스 선택하기
        </BasicButton>
      </div>
    </section>

    <section>
      <ul class="font-size--14 color--nice-grey outer">
        <li>펀다에이아이BNPL은 매출 데이터를 기반으로 결제 한도를 즉시 확인할 수 있습니다.</li>
        <li>결제 후 매출의 일부가 자동으로 상환되어 편리하게 이용하실 수 있습니다.</li>
        <li>이자와 수수료는 결제 금액에 따라 차등 적용됩니다.</li>
      </ul>
    </section>

    <v-footer fixed>
      <v-layout justify-center>
        <v-btn
          text
          color="grey"
          height="25"
          :disabled="requestLoanLoading"
          style="text-decoration: underline"
          :to="'/'"
        >
          돌아가기
        </v-btn>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { commaFormat } from '@/filter/number'
import { locationRedirect } from '@/util'

export default {
  data() {
    return {
      offer: null,
      requestLoanLoading: false,
      getOfferLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('contract', { contractCurrent: 'current' }),
    ...mapGetters('loan', [
      'isFastLoanOfferRequest',
      'investingPullRevenue',
      'isEarlyPaymentEnabled',
    ]),
    componentGetOffer() {
      const options = {
        options: {
          repayment_period_in_days: 120,
          loan_type: 'bnpl',
        },
      }
      return options
    },
    isLoanRequestable() {
      return this.isFastLoanOfferRequest && this.offer && this.offer.amount >= 100000
    },
    isOfferInProgress() {
      if (!this.offer) return true
      return this.offer.status === 'in_progress'
    },
    formattedInterestRate() {
      return this.offer?.interestRate ? (this.offer.interestRate * 100).toFixed(1) : '-'
    },
    formattedCommissionRate() {
      return this.offer?.commissionRate ? (this.offer.commissionRate * 100).toFixed(1) : '-'
    },
    formattedRepaymentRatio() {
      return this.offer?.repaymentRatio ? (this.offer.repaymentRatio * 100).toFixed(1) : '-'
    },
  },
  async created() {
    _meta({
      titles: ['펀다에이아이BNPL 결제'],
    })

    try {
      await this.validateUserRequirements1()

      const { requestProcess } = this.$route.query
      if ([true, 'true'].includes(requestProcess)) {
        await this.request()
      }
    } catch (error) {
      console.error('사전 체크 중 오류 발생:', error)
    }
  },
  methods: {
    commaFormat,
    ...mapActions('loan', ['updateOffer']),
    ...mapActions('evaluation', [
      'isKcsAgreements',
      'isHometaxAccounts',
      'getCreditEvaluationsCurrent',
    ]),

    handleOfferUpdate(offer) {
      this.updateOffer(offer)
    },

    async request() {
      await this.$router.push('/')
    },
    async validateUserRequirements1() {
      const creditData = await this.getCreditEvaluationsCurrent()
      if (Object.keys(creditData).length === 0) {
        return this.$router.replace({
          path: '/factoring/confirm',
          query: {
            next: '/loan/funda-bnpl',
            redirectPath: '/loan/funda-bnpl',
          },
        })
      }
    },
    async goToMain() {
      await this.$router.push('/')
    },
  },
  components: { GetOffer: () => import('@/components/loan/GetOffer.vue') },
}
</script>

<style lang="scss" scoped>
.debug-info {
  margin: 20px;
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-family: monospace;
  font-size: 14px;

  p {
    margin: 5px 0;
    color: #666;
  }
}

.loan-terms {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px 20px;

  .term-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    .term-label {
      color: #666;
      font-size: 14px;
      min-width: 80px;
      margin-right: 12px;

      &::after {
        content: ':';
      }
    }

    .term-value {
      color: #333;
      font-size: 14px;
      font-weight: 500;
    }
  }
}
</style>
